// PROPOSITO: la barra de abajo. Es lo que hace que esto se sienta una app y no una web.
// DEPENDENCIAS: react-router-dom, lucide-react.
//
// PATRON: FitFlow (docs/fuentes/Ejemplos de UI). Cuatro cosas, todas verificadas ahi:
//   1. ICONO ademas de texto. Una barra de solo texto se lee como un menu de pagina web. El icono
//      es lo que se reconoce de un vistazo, sin leer, que es como se usa esto entre serie y serie.
//   2. FLOTA sobre el fondo, separada de los bordes y con esquinas muy redondas, en vez de estar
//      pegada abajo de lado a lado.
//   3. El activo lleva FONDO tenue ademas de color: el color solo no basta para quien no lo
//      distingue bien, y ademas se pierde sobre fondos claros.
//   4. Fondo translucido con desenfoque: el contenido que pasa por debajo se intuye, y eso da la
//      sensacion de profundidad que separa una app nativa de una pagina.
//
// NO OBVIO: el area tactil sigue siendo de 44px aunque el icono mida 20. Lo que se toca y lo que se
// dibuja no son lo mismo, y WCAG mide lo primero.

import { NavLink } from 'react-router-dom'
import { CalendarCheck, LineChart, User, UtensilsCrossed } from 'lucide-react'

const DESTINOS = [
  { a: '/hoy', texto: 'Hoy', Icono: CalendarCheck },
  { a: '/comida', texto: 'Comida', Icono: UtensilsCrossed },
  { a: '/progreso', texto: 'Progreso', Icono: LineChart },
  { a: '/perfil', texto: 'Perfil', Icono: User },
]

export function BarraDeNavegacion() {
  return (
    <nav
      aria-label="Navegación principal"
      className="fixed inset-x-0 bottom-0 z-navegacion px-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))]"
    >
      <ul className="mx-auto flex w-full max-w-lg items-center rounded-2xl border border-borde bg-superficie/90 px-1 py-1 shadow-lg backdrop-blur-xl">
        {DESTINOS.map(({ a, texto, Icono }) => (
          <li key={a} className="flex-1">
            <NavLink
              to={a}
              end={a === '/perfil'}
              className={({ isActive }) =>
                `flex h-tactil flex-col items-center justify-center gap-0.5 rounded-xl transition-colors duration-rapido ${
                  isActive ? 'bg-primario-contenedor text-primario' : 'text-sobre-tenue'
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <Icono size={20} strokeWidth={isActive ? 2.4 : 1.8} aria-hidden />
                  <span className={`text-cuerpo-sm ${isActive ? 'font-fuerte' : ''}`}>{texto}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  )
}
